<template>
  <v-form ref="imageUploadForm">
    <image-uploader
      ref="image"
      :max-width="2048"
      :quality="0.9"
      :preview="true"
      accept="image/*"
      do-not-resize="['gif', 'svg']"
      required
      :rules="imageRules"
      output-format="blob"
      @input="setImage"
    />
    <v-text-field
      v-model="imageDescription"
      label="Opis slike"
    />

    <v-btn
      color="primary"
      variant="outlined"
      data-cy="upload-journal-photo"
      :loading="uploadInProgress"
      @click="uploadImage"
    >
      Naloži sliko
    </v-btn>
  </v-form>
</template>

<script>
export default {
  name: 'JournalImageUploader',
  props: ['projectId', 'date'],
  data() {
    return {
      uploadInProgress: false,
      image: null,
      imageName: null,
      imageRules: [
        v => !!v || 'Slika je obvezna',
      ],
      imageDescription: null,
      newImageDatePickerOpen: false,
    }
  },
  methods: {
    setImage(image, imageName) {
      this.image     = image;
      this.imageName = imageName;
    },
    async uploadImage() {
      if ((await this.$refs.imageUploadForm.validate()).valid) {
        this.uploadInProgress = true;

        const projectId   = this.projectId;
        const image       = this.image;
        const imageName   = this.imageName;
        const imageDate   = this.date;
        const description = this.imageDescription;

        await this.$store.dispatch('uploadSiteLogImage', {
          projectId,
          image,
          imageName,
          imageDate,
          description
        });

        this.uploadInProgress = false;
        this.imageDescription = '';
      }
    },
  }
}
</script>
